import { chatbotV1 } from './common/clients';

export default {
  ask: (body) => chatbotV1.post('/places/recommendations', body),
};
